import { render, staticRenderFns } from "./VCameraInput.vue?vue&type=template&id=c1adae9e"
import script from "./VCameraInput.vue?vue&type=script&lang=js"
export * from "./VCameraInput.vue?vue&type=script&lang=js"
import style0 from "./VCameraInput.vue?vue&type=style&index=0&id=c1adae9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports